import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import $ from 'jquery';
import DataTable from 'datatables.net';

export default class UserTable extends React.PureComponent {
    static propTypes = {
        customers: PropTypes.array.isRequired,
        productId: PropTypes.string.isRequired,
        nameFilter: PropTypes.string.isRequired,
    };

    getAverageResult = (type, user) => {
        const {productId} = this.props;
        let counter = 0;
        let points = 0;

        user.exerciseResults[parseInt(productId, 10)]
            .filter(result => (result.type === type))
            .forEach(result => {
                points += parseInt(result.rating, 10);
                counter++;
            });
        return parseInt(points / counter, 10) || 0;
    };

    getTries = (type, user) => {
        const {exerciseResults} = user;
        const {productId} = this.props;
        const tries = exerciseResults[parseInt(productId, 10)]
            .filter(result => (result.type === type))
            .length;
        return tries > 0 ? tries : 0;
    };

    getFilteredCustomers = () => {
        const { customers, nameFilter, productId } = this.props;
        return customers
            .filter((user) => (user.product_id === productId))
            .filter((user) => (user.first_name.startsWith(nameFilter) || user.last_name.startsWith(nameFilter)))
    };

    componentDidMount() {
        $('#dataTable').DataTable({
            "paging":   false,
            "ordering": true,
            "info":     false,
            "searching": false
        });
        $('.dataTables_length').addClass('bs-select');
    }

    render() {
        const { productId } = this.props;
        return (
            <div className="table-responsive animate-table">
                <table id="dataTable" className="table table-stripped ">
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td>Prüfungen (Anzahl)</td>
                            <td>&Oslash;-Ergebnis Prüfungen</td>
                            <td>Übungen (Anzahl)</td>
                            <td>&Oslash;-Ergebnis Übungen</td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getFilteredCustomers().map(customer => (
                            <tr key={Math.floor(Math.random()*16777215).toString(16)}>
                                <td><Link to={`${productId}/${customer.user_id}`}>{`${customer.first_name} ${customer.last_name}`}</Link></td>
                                <td>{this.getTries('exam', customer)}</td>
                                <td>{this.getAverageResult('exam', customer)}</td>
                                <td>{this.getTries('exercise', customer)}</td>
                                <td>{this.getAverageResult('exercise', customer)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/features/products/UserTable.js